// Port of Utils.buildOriginalPath() / Utils.buildURL() path assembly.

export type RouteParams = {
    teamId?: string
    boardId?: string
    viewId?: string
    cardId?: string
}

export function buildBoardPath({teamId, boardId, viewId, cardId}: RouteParams): string {
    if (!teamId) {
        return boardId ? `/board/${[boardId, viewId, cardId].filter(Boolean).join('/')}` : '/'
    }
    const segments = [boardId, viewId, cardId].filter(Boolean)
    return `/team/${teamId}${segments.length ? `/${segments.join('/')}` : ''}`
}

export function withQuery(path: string, query: Record<string, string | undefined>): string {
    const params = new URLSearchParams()
    Object.entries(query).forEach(([key, value]) => {
        if (value) {
            params.set(key, value)
        }
    })
    const qs = params.toString()
    return qs ? `${path}?${qs}` : path
}
